import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SearchInput.css';
import searchImg from './search.svg';

class SearchInput extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string,
  };
  static defaultProps = {
    value: '',
  };

  state = {
    value: this.props.value || '',
  };

  handleInputChange = e => {
    e.preventDefault();
    const { value } = e.target;
    this.setState({ value });
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.onSubmit(this.state.value);
  };

  clearInput = () => {
    this.setState({ value: '' });
  };

  render() {
    const { placeholder } = this.props;
    const { value } = this.state;

    return (
      <form className={s.form} onSubmit={this.handleSubmit}>
        {value && <span className={s.clean} onClick={this.clearInput} />}
        <input
          value={value}
          placeholder={placeholder}
          onChange={this.handleInputChange}
          className={s.input}
          type="text"
        />
        <button className={s.submit} type="submit">
          <img src={searchImg} width="26" alt="search" />
        </button>
      </form>
    );
  }
}

export default withStyles(s)(SearchInput);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchInput/SearchInput.js